import { useEffect, useState } from "react";
import { createUserManager } from "redux-oidc";
import { useGetTenantQuery, useReleaselicenseMutation } from "../../redux/api/BaseApi";
import { useReduxSelector } from "../../redux/hooks";
import { trimChar } from "../../utils/utils";
import { Spinny } from "../Nav/Spinny";
import { oAuthSettings } from "./AuthSettings";

const SignoutPage = () => {
    const [releaseLicense] = useReleaselicenseMutation();
    const user = useReduxSelector((state) => state.auth.user);
    const { data: tenant } = useGetTenantQuery();

    const [frameLoaded, setFrameLoaded] = useState<boolean>();
    const logMeOut = async () => {

        await releaseLicense(null);
        //var user = await userManager.getUser();

        let settings = oAuthSettings;
        if (tenant?.Authority)
            settings.authority = tenant?.Authority

        //First release the current license, THEN release the token and redirect to the logout page.
        const userManager = createUserManager(settings);
        console.warn('Signing out', user.id_token);
        await userManager.signoutRedirect({ id_token_hint: user.id_token });
    };

    useEffect(() => {
        if (frameLoaded)
            logMeOut();
    }, [frameLoaded]);

    const iFrameLoaded = (e) => {
        //console.log('iFrameLoaded', e)
        setFrameLoaded(true);
    }


    return (
        <>
            <iframe title="signout frame" className="hidden" src={`${trimChar(tenant?.Tenant_Url, '/')}/OAuth/Signout`} onLoad={iFrameLoaded} ></iframe>
            {/* Logout animation */}
            <><Spinny text={frameLoaded ? 'Releasing license...' : 'Signing out of Revelation helpdesk...'} /></>
        </>
    );
};

export default SignoutPage;
